const generateAuthData = (token) => {
  const expires = new Date().getTime() + 1000 * 60 * 20 // 20 minutes
  const authData = { expires, token }

  return authData
}

export default generateAuthData
